import React from "react";

export const CommentContext = React.createContext({});
